export default "__VITE_ASSET__24d952eb__"